export enum Transfers {
  NO_TRANSFER = 'No Transfer'
}
